// extracted by mini-css-extract-plugin
export default {"Container":"AuthLayout_Container__Xd9-E","Form":"AuthLayout_Form__KaI3t","Side":"AuthLayout_Side__lulS7"};